<template>
  <div class="p-the-template-i">
    <TheBreadcrumb />
    <div class="p-the-template-i__inner">
      <div class="p-the-template-i__header">
        <slot name="header">
          <CommonHeading v-if="heading">{{ heading }}</CommonHeading>
        </slot>
      </div>

      <div class="p-the-template-i__body">
        <div class="p-the-template-i__body__inner">
          <div
            v-if="
              indicateSearchForm || indicateSearchButton || indicateSortedButton
            "
            class="p-the-template-i__body__header"
          >
            <div
              v-if="indicateSearchForm"
              class="p-the-template-i__search"
              :class="executeSearchFormDomAnimation ? searchFormClassName : ''"
              :style="executeSearchFormDomAnimation ? (shownSearchFormState ? {} : serchFormStyle) : {}"
              ref="searchFormElement" 

            >
              <FormSearch
                v-model:search="search"
                @do-search="doSearch"
                :placeholder="searchPlaceholder"
              />
            </div>
            <div
              v-if="indicateSearchButton || indicateSortedButton"
              class="p-the-template-i__right-col"
            >
              <div
                v-if="indicateSearchButton"
                class="p-the-template-i__shown-search-form-button"
              >
                <button
                  @click="switchSearchFormState"
                  class="p-the-template-i__shown-search-form-button__button"
                >
                  <ButtonRefineBase>検索</ButtonRefineBase>
                </button>
              </div>

              <div v-if="indicateSortedButton" class="p-the-template-i__sorted">
                <ButtonRefine
                  :heading="filterHeading"
                  icon="sorted"
                  :refine-item-list="sorted.itemList"
                  v-model:refine="sorted.target"
                  :shown="sorted.shownState"
                  @do-sort="doSort($event)"
                  @switch-refine-state="switchSortedState"
                  :width="widthButtonRefine"
                />
              </div>
            </div>
          </div>
          <div
            class="p-the-template-i__body__content"
            :style="contentElementStyle"
            ref="contentElement"
          >
            <slot name="contents" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { gsap } from "gsap";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import { Options, Vue } from 'vue-class-component';

import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import FormSearch from "@/common/components/atoms/FormSearch.vue";
import ButtonRefine from "@/common/components/atoms/ButtonRefine.vue";
import ButtonRefineBase from "@/common/components/atoms/ButtonRefineBase.vue";
import globals from "@/general/store/modules/globals";

@Options({
  props: {
    sorted: { type: Object, default: () => ({}) },
    filterHeading: { type: String, default: "" },
    heading: { type: [String, Boolean], default: false, required: true },
    indicatedItem: { type: Array, default: ["search", "button"] },
    searchKeyword: { type: String, default: "" },
    searchPlaceholder: { type: String, default: "検索" },
    initShownSearchFormState: { type: Boolean, default: false }
    
  },
  components: {
    TheBreadcrumb,
    CommonHeading,
    FormSearch,
    ButtonRefineBase,
    ButtonRefine
  },
  watch: {
    shownSearchFormState(newVal) {
      this.animationSearchFormDom(this.$refs.searchFormElement, newVal);
    },
    isSp(){
      this.initSearchFormDomAnimation();
    },
    search(newVal) {
      // スマホ表示かつフォームが表示されていて、値が空になったときはアニメーションを実行しない
      if (this.isSp && this.shownSearchFormState && newVal === "") {
        return;
      }
      this.animationSearchFormDom(this.$refs.searchFormElement, this.shownSearchFormState);
    }
  }
})
export default class TheTemplateI extends Vue {
  declare $refs: {
    contentElement: HTMLElement;
    searchFormElement: HTMLElement;
  };
  
  sorted!: any;
  filterHeading!: string;

  // isSp!: boolean;
  closeModalState!: boolean;
  search = "";
  searchUriBase: Array<string> = ["/j03/", "/j04/"];
  executeSearchFormDomAnimation = true;
  shownSearchFormState = true;
  searchFormClassName = "p-the-template-i__search--animation";
  serchFormStyle: Record<string, any> = {
    visibility: "hidden",
    opacity: 0
  };
  get isSp(){
    return globals.isSpScreenWidth;
  }
  $event!: string | number;

  heading!:
    | string
    | boolean;
  indicatedItem!: Array<
    string
  >;
  searchKeyword!: string;
  searchPlaceholder!: string;
  initShownSearchFormState!: boolean;

  get indicateSearchForm() {
    const indicatedItem = this.indicatedItem;
    const keyword = "search";
    return indicatedItem.includes(keyword);
  }

  get indicateSearchButton() {
    const indicatedItem = this.indicatedItem;
    return indicatedItem.includes("searchButton");
  }

  get indicateSortedButton() {
    const indicatedItem = this.indicatedItem;
    const keyword = "sorted";
    return indicatedItem.includes(keyword);
  }

  get contentElementStyle() {
    const executeSearchFormDomAnimation = this.executeSearchFormDomAnimation;
    let styleObject = {};

    if (executeSearchFormDomAnimation === false) {
      styleObject = {
        marginTop: 0
      };
    }

    return styleObject;
  }

  get widthButtonRefine() {
    return "170px";
  }

  doSort($event: any) {
    this.$emit("do-sort", $event);
  }

  mounted() {
    this.indicatedItem;
    this.heading;
    this.searchKeyword;
  }

  created() {
    this.indicatedItem;
    this.heading;
    this.searchKeyword;
    this.search = this.searchKeyword; 
    this.initSearchFormDomAnimation();
    this.initSearchKeyword();
  }

  initSearchKeyword() {
    this.search = this.searchKeyword;
  }

  // doSearch() {
  //   const { searchUriBase } = this;
  //   const max = 1;
  //   const min = 0;
  //   const ramdomNum = Math.floor(Math.random() * (max + 1 - min)) + min;
  //   const apiUri = `${searchUriBase[ramdomNum]}`;

  //   document.location.href = apiUri;
  // }
  async doSearch() {
    this.$emit("do-search", this.search);
  }

  switchSortedState(value: any) {
    this.sorted.shownState = value;
  }

  switchSearchFormState() {
    this.shownSearchFormState = !this.shownSearchFormState;
  }

  initSearchFormDomAnimation() {
    const { isSp, indicateSearchButton, initShownSearchFormState } = this;
    const executeSearchFormDomAnimation = isSp && indicateSearchButton;

    this.executeSearchFormDomAnimation = executeSearchFormDomAnimation;
    this.shownSearchFormState =
      initShownSearchFormState || !executeSearchFormDomAnimation;
  }

  animationSearchFormDom(el: any, shown = this.shownSearchFormState) {
    const { isSp, executeSearchFormDomAnimation } = this;
    const { contentElement } = this.$refs;
    const speed = 0.2;

    const animationStyle = {
      formSearchElement: {
        autoAlpha: shown ? 1 : 0
      },
      contentElement: {
        marginTop:
          isSp && shown && executeSearchFormDomAnimation
            ? `${60 / 16}rem`
            : "0rem"
      }
    };

    gsap.to(el, speed, animationStyle.formSearchElement);
    gsap.to(contentElement, speed, animationStyle.contentElement);
  }
}
</script>

<style lang="scss" scoped>
.p-the-template-i {
  &__inner {
    @include pc {
      max-width: rem(1110);
      margin: 0 auto;
      padding: rem(32) 0 rem(48);
    }
  }

  &__header {
  }

  &__search {
    @include pc {
      width: rem(288);
      min-width: rem(288);
    }

    &--animation {
      @include sp {
        width: 100%;
        position: absolute;
        padding-top: rem(60);
      }
    }
  }

  &__right-col {
    @include sp {
      display: flex;
      flex-direction: flex-end;
      justify-content: space-between;
      position: relative;
      z-index: 1;
    }
  }

  &__shown-search-form-button {
    @include pc {
      display: none;
    }
    @include sp {
      width: cal(136, 288);
      min-width: cal(136, 288);
    }

    &__button {
      @include sp {
        display: block;
        width: 100%;
      }
    }
  }

  &__sorted {
    @include pc {
      width: rem(168);
      min-width: rem(168);
    }
    @include sp {
      width: cal(136, 288);
      min-width: cal(136, 288);
    }
  }

  &__body {
    @include pc {
      margin-top: rem(16);
      padding: rem(64) rem(24) rem(48);
    }
    @include sp {
      padding: rem(24) 0 rem(48);
    }
    background-color: $common-white;
    border-radius: rem(4);

    &__inner {
      @include pc {
        width: cal(840, 1032);
        margin: 0 auto;
      }
    }

    &__header {
      @include pc {
        display: flex;
        justify-content: space-between;
      }
      position: relative;
    }

    &__content {
    }
  }
}
</style>
